// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vdc6","title":"styles_title__36y0d"};